// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../registration-vue/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#radio-input-confirm-city-change .custom-radio{margin-left:0!important}", ""]);
// Exports
module.exports = exports;
